import configureStoreDev from './configureStore.dev'
import configureStoreProd from './configureStore.prod'

const configureStore = process.env.REACT_APP_ENV === 'production' ? configureStoreProd : configureStoreDev

export default configureStore
export const getStore = process.env.REACT_APP_ENV === 'production' ? configureStoreProd.getStore : configureStoreDev.getStore